
import React, { Component } from 'react';  
import {Spinner} from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import Assign  from './Assign';
import {searchReAssignRecords, SearchQANames, submitReAssignRecords, closeModalPopUp, ResetAll} from '../WorkListing/WorklistingAction'
import ShowModalPopUp from '../ShowModalPopUp';

class ReAssignindex extends Component {

  componentDidMount(){    
    this.props.actioninventoryUserMapped()
  }
 
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    
    let moduleAccess = _.find(this.props.loginAction.modulescreens, {"moduleUId": "RE-ASSIGN"})
    return(
      <div className={(style) ? 'user' : "userSmall"}>
      {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
      {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null} 
       <Assign inventory={this.props.inventoryMapped} action={this.props} searchData={this.props.searchReAssignData}
       QANameList={this.props.QANameList} reassiged={this.props.reassiged} accessPermission={moduleAccess ? moduleAccess.screens[0].accessPermission: 'READ'}
        /> 
      </div>
      )
  }
}    
function mapStateToProps(state){
  return{
   inventoryMapped: state.UserReducer.inventoryMapped,
   searchReAssignData: state.WorklistingReducer.searchReAssignData, 
   QANameList: state.WorklistingReducer.QANameList,
   size: state.UserReducer.large,
   isPending:state.WorklistingReducer.isPending,   
   showerror:  state.WorklistingReducer.showerror, 
   errmessage:  state.WorklistingReducer.errmessage, 
   reassiged: state.WorklistingReducer.reassiged, 
   loginAction: state.LoginReducer.loginAction,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  searchReAssignRecords:  (a) =>dispatch(searchReAssignRecords(a)),  
  submitReAssignRecords:  (a) =>dispatch(submitReAssignRecords(a)),    
  SearchQANames:  (a) =>dispatch(SearchQANames(a)),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  ResetAll:  () =>dispatch(ResetAll()), 
  TokenValidation : (a) => dispatch(TokenValidation(a))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReAssignindex);


